import React, { useEffect, useRef, useState } from "react";
import { BsCheck, BsFileEarmarkPdf } from "react-icons/bs";
import { TbFilePlus } from "react-icons/tb";

const FileDropAnimation = () => {
    const containerRef = useRef();
    const handRef = useRef();
    const fileRef = useRef();
    const btnRef = useRef();

    const [hovered, setIsHovered] = useState(false)
    const [fileDropped, setFileDropped] = useState(false);
    const [animate, setAnimate] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    if (!fileDropped) {
                        setAnimate(true);
                    }
                } else {
                    setAnimate(false);
                    setFileDropped(false);
                    setIsHovered(false);
                }
            },
            { threshold: 0.5 }
        );

        if (containerRef.current) {
            observer.observe(containerRef.current);
        }

        return () => {
            if (containerRef.current) observer.unobserve(containerRef.current);
        };
    }, []);

    useEffect(() => {
        let animationFrame;

        const checkHover = () => {
            if (!handRef.current || !btnRef.current) return;

            const handRect = handRef.current.getBoundingClientRect();
            const btnRect = btnRef.current.getBoundingClientRect();

            const isOver =
                handRect.left < btnRect.right &&
                handRect.right > btnRect.left &&
                handRect.top < btnRect.bottom &&
                handRect.bottom > btnRect.top;

            if (isOver) {
                setTimeout(() => {
                    setFileDropped(true)
                }, 1500);
            }
            setTimeout(() => {
                setIsHovered(true)
            }, 500);


            animationFrame = requestAnimationFrame(checkHover);
        };

        animationFrame = requestAnimationFrame(checkHover);
        return () => cancelAnimationFrame(animationFrame);
    }, []);

    useEffect(() => {
        if (animate) {
            setFileDropped(false)
        }
    }, [animate])


    return (
        <div className="animation_container" ref={containerRef}>
            <div className="animation_container_inner">
                <div className="drop_box">
                    {fileDropped ? (
                        <div className={`drop_box_inner_full`}>
                            <i className="drop_box_inner_check"><BsCheck /></i>
                        </div>

                    ) : (
                        <div className={`drop_box_inner`}>
                            <i><TbFilePlus /></i>
                            <p>Drop file</p>
                        </div>
                    )}
                    <button
                        ref={btnRef}
                        className={`drop_box_btn ${hovered ? "hovered" : ""} ${fileDropped ? "dropped" : ""}`}
                        disabled
                    >
                        Upload
                    </button>
                </div>

                <div className="file_animation">
                    <div
                        ref={handRef}
                        className={`hand ${animate ? "hand-animate" : ""}`}
                    >
                        <div className="cursor_icon"></div>
                    </div>
                    <div
                        ref={fileRef}
                        className={`file_icon ${animate ? "file-animate" : ""}`}
                    >
                        {/* <BsFileEarmarkPdf /> */}
                        <div className="drop_file_cont">
                            <div className="file_stack">

                            <div className="drop_file pdf_file"></div>
                            <div className="drop_file excel_file"></div>
                            <div className="drop_file word_file"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default FileDropAnimation;
